export default __webpack_public_path__ + "static/media/020204202156100.52af09f3.png";